import React, { useState } from 'react';
import { AddCircle } from '@material-ui/icons';
import { Typography, Grid, IconButton } from '@material-ui/core';
import JobFormPage from './JobFormPage';
import { Text, Colors, Checkbox } from 'library';
import { FieldStates } from '../FormTypes';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { useUserContext } from 'UserContext';
import { formatAddress } from 'shared';
import AddBusinessLocationForm from 'parent-portal/BusinessLocation/AddBusinessLocationForm';
import { JobFormFields } from 'parent-portal/forms/JobRequestTypes';
import { setBreakMinutes } from 'parent-portal/forms/businessPreferenceMethods';

interface IBusinessAddressSelectProps {
    fieldStates: FieldStates<JobFormFields>;
}

export default function BusinessAddressSelect({ fieldStates }: IBusinessAddressSelectProps) {
    const { user } = useUserContext();
    const [isAddingAddress, setIsAddingAddress] = useState(false);
    const { goToNext, businessPreferences } = useJobFormContext();
    const address = fieldStates.address;
    const breakLength = fieldStates.breakLength;
    const breakRequired = fieldStates.breakRequired;

    function onAddressChange(addressId: number) {
        const addressValue = address.value || [];

        if (addressValue.includes(addressId)) {
            address.setValue(addressValue.filter((x) => x !== addressId));
        } else {
            address.setValue([...addressValue, addressId]);
            setBreakMinutes(businessPreferences, breakRequired, breakLength, addressId);
        }
    }

    function getNewAddressForm() {
        if (isAddingAddress) {
            return (
                <AddBusinessLocationForm
                    cancel={() => setIsAddingAddress(false)}
                    complete={() => setIsAddingAddress(false)}
                    optionalContact={true}
                />
            );
        }

        return (
            <Grid container item direction="row" alignItems="center" spacing={3}>
                <Grid item>
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                        Add Address
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <IconButton id="add-address" disabled={isAddingAddress} onClick={() => setIsAddingAddress(true)}>
                        <AddCircle style={{ position: 'relative', color: Colors.darkNavy }} />
                    </IconButton>
                </Grid>
            </Grid>
        );
    }

    const user_addresses = user?.address;

    return (
        <JobFormPage
            title="Select the locations for this job."
            onNextClicked={goToNext}
            nextDisabled={!address.value || !address.value.length || isAddingAddress}
            hideActionButtons={isAddingAddress}
        >
            <div style={{ marginTop: 30 }} />

            <Text textStyle={{ marginTop: 40 }} variant="h2">
                Addresses
            </Text>

            {user_addresses?.map((x, i) => (
                <Checkbox
                    key={x.id}
                    label={formatAddress(x)}
                    checked={(address.value || []).includes(x.id)}
                    onChange={() => onAddressChange(x.id)}
                />
            ))}

            {getNewAddressForm()}
        </JobFormPage>
    );
}
